import { useCallback } from 'react'
import { ScoresContext } from './context'
import { Select } from '..'
import { authWall } from '@/utils'
import { analytics } from '@/services'
import { queryClient } from '@/services/api'

export const IndustrySelector = () => {
  const { setIndustry, selectedOption, options } = ScoresContext.useIndustrySelector()

  const onSelect = useCallback(
    o => {
      analytics.track('industry_filter', {
        industry: options.find(({ value }) => value === o.value)?.label
      })

      authWall(() => {
        setIndustry(o.value)
        queryClient.client.removeQueries({ queryKey: ['answers'] })
        queryClient.client.removeQueries({ queryKey: ['stories'] })
      })()
    },
    [setIndustry]
  )

  return (
    <Select
      searchable
      loadInitialValue
      options={options}
      selectedOption={selectedOption}
      setSelectedOption={onSelect}
      debugName="Industry Select"
      // @ts-ignore
      variants={['noError', 'fullWidth']}
    />
  )
}
